import { ChevronRight, Home } from "lucide-react";

const breadcrumbLabels = {
  dashboard: "Dashboard",
  restaurants: "Restaurants",
  revenuehistory: "Revenue History",
  revenueentry: "Revenue Entry",
  reports: "Reports",
  expenses: "Expenses",
  expenseentry: "Expense Entry",
  pettycashsummary: "Expense Summary",
  profitloss: "P&L Report",
  cashhandover: "Cash Handover",
  cashhistory: "Cash History",
  cashreconciliation: "Cash Reconciliation",
  royaltyentry: "Royalty Entry",
  royaltysummary: "Royalty Summary",
  targets: "Restaurant Targets",
  targetanalytics: "Target Analytics",
  users: "Users",
  employees: "Employees",
  documents: "Documents",
  auditlogs: "Audit Logs",
  datamanager: "Data Manager",
  credentials: "Credentials",
  categories: "Revenue Categories",
  storemanagers: "Store Managers",
  anomalies: "Anomaly Monitor",
  issues: "Issue Tracker",
  platformdeductions: "Platform Fees",
  headofficeexpenses: "HO Expenses",
  restaurantcash: "Restaurant Cash",
};

const breadcrumbParents = {
  restaurants: ["Daily Operations"],
  revenueentry: ["Daily Operations"],
  expenseentry: ["Daily Operations"],
  targets: ["Targets"],
  targetanalytics: ["Targets"],
  revenuehistory: ["Financial Reports"],
  reports: ["Financial Reports"],
  profitloss: ["Financial Reports"],
  pettycashsummary: ["Financial Reports"],
  cashhandover: ["Cash & Royalty"],
  cashhistory: ["Cash & Royalty"],
  cashreconciliation: ["Cash & Royalty"],
  royaltyentry: ["Cash & Royalty"],
  royaltysummary: ["Cash & Royalty"],
  users: ["Team & Documents"],
  employees: ["Team & Documents"],
  documents: ["Team & Documents"],
  auditlogs: ["Settings"],
  datamanager: ["Team & Documents"],
  credentials: ["Team & Documents"],
  categories: ["Settings"],
  storemanagers: ["Settings"],
  anomalies: ["Support"],
  issues: ["Support"],
  platformdeductions: ["Cash & Royalty"],
  headofficeexpenses: ["Cash & Royalty"],
  restaurantcash: ["Cash & Royalty"],
};

const Breadcrumb = ({ activeTab, setActiveTab, userRole }) => {
  const parents = breadcrumbParents[activeTab] || [];
  const currentLabel = breadcrumbLabels[activeTab] || "Dashboard";
  const homeTab = userRole === "restaurant_manager" ? "revenueentry" : "dashboard";

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-4">
      <button
        onClick={() => setActiveTab(homeTab)}
        className="flex items-center hover:text-blue-600 transition-colors"
      >
        <Home className="w-4 h-4" />
      </button>
      
      {parents.map((parent, index) => (
        <div key={index} className="flex items-center space-x-2">
          <ChevronRight className="w-4 h-4 text-gray-400" />
          <span className="text-gray-500">{parent}</span>
        </div>
      ))}
      
      {activeTab !== homeTab && (
        <div className="flex items-center space-x-2">
          <ChevronRight className="w-4 h-4 text-gray-400" />
          <span className="font-medium text-gray-900">{currentLabel}</span>
        </div>
      )}
    </nav>
  );
};

export default Breadcrumb;
